import { render } from "./OtpView.vue?vue&type=template&id=7bb69b37&scoped=true"
import script from "./OtpView.vue?vue&type=script&lang=js"
export * from "./OtpView.vue?vue&type=script&lang=js"

import "./OtpView.vue?vue&type=style&index=0&id=7bb69b37&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bb69b37"]])

export default __exports__